import {
  DisplayAdStartpageSlot01,
  DisplayAdStartpageSlot02,
} from '@xing-com/crate-ads-display-ads';
import { Ad, SiteSections } from '@xing-com/crate-ads-native-ads';
import type { AdFields } from '@xing-com/crate-ads-native-ads';

import * as Styles from './ad-section.styles';

type AdSectionProps = {
  placement: 'top' | 'bottom';
  ads: AdFields[];
  isCompleted: boolean;
  isAdExperiment: boolean;
  isSkipped: boolean;
};

export const AdSection: React.FC<AdSectionProps> = ({
  placement,
  ads,
  isCompleted,
  isAdExperiment,
  isSkipped,
}) => {
  if (isAdExperiment && !isSkipped && !isCompleted) {
    return null;
  }

  const isTop = placement === 'top';
  const nativeAd = ads[isTop ? 0 : 1];
  const NativeAdContainer = isTop
    ? Styles.NativeAdTopContainer
    : Styles.NativeAdBottomContainer;
  const DisplayAd = isTop ? DisplayAdStartpageSlot01 : DisplayAdStartpageSlot02;

  if (isAdExperiment && nativeAd) {
    return (
      <NativeAdContainer>
        <Ad {...nativeAd} sectionId={SiteSections.JobsInline} isLoggedOut />
      </NativeAdContainer>
    );
  }

  return <DisplayAd />;
};
